"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=require("@material-ui/core/styles");let b=a.makeStyles(a=>({tagText:{backgroundColor:a=>a.backgroundColor,borderRadius:3,color:a=>a.color,fontSize:12,padding:a.spacing(.5,1)}}));exports.default=b
//# sourceMappingURL=styles.js.map
